module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-1-dde5877a84e98f2cbdb403845e0b6f3b.jpg";